import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {GreatForm} from 'components/common';
import {SelectField} from 'components/common/rc-fields';
import {changeUserRole} from 'api/users';
import {getOptions} from 'utils/common';

const rolesToChangeMap = {
  teacher: 'Teacher',
  school_coordinator: 'School Coordinator',
};

const rolesToChangeOptions = getOptions(rolesToChangeMap);

const UserRoleChangeForm = ({user, form, onSubmitSuccess}) => (
  <GreatForm
    form={form}
    submitFn={(payload) => changeUserRole({userId: user.id, ...payload})}
    onSuccess={onSubmitSuccess}
    successMsg="User role has been changed successfully!"
  >
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SelectField
          name="role"
          label="New Role"
          options={rolesToChangeOptions}
          initialValue={user.role}
          rules={[{required: true, message: 'Please select a new role'}]}
          form={form}
          autoComplete="off"
          renderValue={(value) => rolesToChangeMap[value]}
        />
      </Grid>
    </Grid>
  </GreatForm>
);

UserRoleChangeForm.propTypes = {
  form: formShape.isRequired,
  user: PropTypes.object.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};

UserRoleChangeForm.defaultProps = {
  initialValues: {},
};

export default createForm()(UserRoleChangeForm);
